import script from "./COG.vue?vue&type=script&lang=js"
export * from "./COG.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__